import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/MOVE_SETTING';

export const {
    action: fetchInstitutions,
    success: fetchInstitutionsSuccess,
    failed: fetchInstitutionsFailed,
} = createAction(
    `${domain}/FETCH_INSTITUTIONS`,
    organizationId => ({organizationId}),
    institutions => ({institutions}),
);

export const {
    action: moveSetting,
    success: moveSettingSuccess,
    failed: moveSettingFailed,
} = createAction(
    `${domain}/MOVE_SETTING`,
    (childId, setting, date, includeObservations) => ({childId, setting, date, includeObservations}),
    childId => ({childId}),
);
